import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
	state: {
		noticias : ''
	},
	getters: {
		categoriaNoticias : (state) => {

			let noticias = state.noticias;

			if(!!noticias){

				let categorias = new Array();

				noticias.forEach( noticia => {
					if(!categorias.some(c => c.slug == noticia.categoria.slug )){
						categorias.push(noticia.categoria)
					}
				});

				return categorias;
			}
		},
		getNoticias : state => state.noticias
	},
	actions: {
		requestNoticias : ({commit},) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/noticias`)
				.then(response => {
					commit('setNoticias', response.data);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestNoticia : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/noticia/${slug}`)
				.then(response => {
					
					(!!response.data) ? resolve(response.data) : reject(false);
				})
				.catch(err => reject(err));

			});
		},
		requestSimilares : ({},requestdata) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/noticias/${requestdata.cat}`)
				.then(response => {
					let noticias = response.data.filter(e => (!!e.imagen_listado.enlace && e.slug != requestdata.id));
					resolve(noticias.slice(0,4));
				})
				.catch(err => reject(error));
			});
		}
	},
	mutations: {
		setNoticias : (state, noticias) => {
			state.noticias = noticias;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js